import React from 'react';
import { isEmpty } from 'lodash';
import noImage from '../../../../assets/images/no-image.png';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';
import { useS3Url } from '../../../AssetLibrary/Assets/useS3Url';

function ProductCareImage({ dataValue, isPageDisable, handleImageUpload, handleImageDelete, t }) {
  const isBase64Image = dataValue?.image?.includes("data:image/");
  const resolvedImageUrl = useS3Url(isBase64Image ? null : dataValue?.image);
  const imageSrc = isBase64Image ? dataValue.image : resolvedImageUrl || noImage;

  return (
    <div className="image-container mr-0 d-flex">
      <div>
        <img width="60px" height="60px" src={imageSrc} alt="croppedImage" />
      </div>
      {!isPageDisable && (
        <div className="d-flex flex-column">
          <CustomTooltip placement="top" tooltipText={t('SPEC_TEMP_LIBRARY.UPLOAD_IMAGE')}>
            <button aria-label="upload" className="btn btn-upload-img" onClick={handleImageUpload} type="button">
              <span className="icon-Upload-1" aria-hidden="true" />
            </button>
          </CustomTooltip>
          {!isEmpty(dataValue?.image) && (
            <CustomTooltip placement="top" tooltipText={t('SPEC_TEMP_LIBRARY.REMOVE_IMAGE')}>
              <button aria-label="delete" className="btn btn-upload-img" onClick={handleImageDelete} type="button">
                <span className="icon-Delete" aria-hidden="true" />
              </button>
            </CustomTooltip>
          )}
        </div>
      )}
    </div>
  );
}

export default ProductCareImage;
